import { useState, useEffect } from "react";
import "./CloudApiKeyCard.scss";
import service from "../../services/Service.js";
import { Space, Button, notification, Modal} from "antd";
import { SaveOutlined } from "@ant-design/icons";
import { withLocale } from '../../l10n/index.jsx';
import { logout } from "../../api/user.js";
import withNavigation from '../hooks/withNavigation.jsx';


function CloudApiKeyCard({ lang, ident, navigate }) {

  const [cloudApiKey, setCloudApiKey] = useState("");
  const [userData, setUserData] = useState({});

  useEffect(() => {

    const fetchUserKey = async () => {
      const uuid = ident;
      await service.get("users/" + uuid).then((res) => {
        if (res.data.ok === false) {
          notification["error"]({
            message: res.data.message,
          });
          return;
        }
        if (!res.data.data) {
          return;
        }
        setUserData(res.data.data[0]);
        setCloudApiKey(res.data.data[0].api_key_cloud);
      });
    };
    fetchUserKey();
  }, [ident, lang]);

  const onSubmit = async () => {

    const updateUser = async () => {
      const updatedData = { ...userData, api_key_cloud: cloudApiKey };
      try {
        const result = await service.put("users/" + userData.uuid, updatedData);
        if (result.data.ok === false) {
          notification["error"]({
            message: result.data.message,
          });
          return;
        } else {
          notification["success"]({
            message: lang.handle('Clave API Cloud actualizada correctamente'),
          });
          await logout();
          navigate("/login");
        }
      } catch (error) {
        console.error("Error updating user:", error);
      }
    };

    Modal.confirm({
        title: lang.handle("Su sesión se cerrará para aplicar los cambios"),
        content: lang.handle("Tendrá que volver a iniciar sesión para usar la nueva clave"),
        onOk: updateUser,
      });
  };

  return (
    <div className="form-group row">
      <label
        htmlFor="api_key_cloud"
        className="col-sm-2 col-form-label newCard-form-text"
      >
        {" "}
        {lang.handle('Clave API Cloud')}{" "}
      </label>
      <div className="col-sm-10">
        <input
          className="form-control"
          type="text"
          id="api_key_cloud"
          name="api_key_cloud"
          value={cloudApiKey}
          onChange={(e) => setCloudApiKey(e.target.value)}
        />
      </div>
      <div className="align-right">
        <Space>
          <a href={import.meta.env.VITE_WIKI_URL} target="_blank" rel="noopener noreferrer">
            {lang.handle('¿Dónde encuentro mi clave?')}
          </a>
        </Space>
        <Space>
          <Button
            id="button-save"
            htmlType="submit"
            type="primary"
            icon={<SaveOutlined />}
            onClick={onSubmit}
          >
            {lang.handle('Guardar')}
          </Button>
        </Space>
      </div>
    </div>
  );
}

export default withLocale(withNavigation(CloudApiKeyCard));
